import React, { Component } from 'react';
import { Header, Icon, Popup, Segment } from 'semantic-ui-react';
import { ResponsiveBar } from '@nivo/bar';

import { getNivoTheme, CHART_HEIGHT, CHART_HEIGHT_MOBILE } from '../../Charts/utils';
import { CustomContainer } from '../../common';
import { formatDatetime } from '../../Utils';

const MESSAGES = {
  SHOW_RECENT_ACTIVITIES: `
    使用者在過去一定時間內的活動情形
  `,
};

const STYLES = {
  QUESTION_ICON: {
    float: 'right',
    cursor: 'pointer',
    color: '#7f8c8d',
  },
};

export default class Activities extends Component {
  fetchDailyActivites = (at) => {
    this.props.getPersonaDailyActivitiesDetails(
      this.props.personaId,
      at,
    );
  }

  render() {
    const {
      data,
      isFetching,
      isMobile,
      title,
    } = this.props;

    const hasRecentActivities = Array.isArray(data) && (data.length > 0);

    return (
      <div ref={this.setWrapperRef}>
        <CustomContainer>
          <Header as={isMobile ? 'h3' : 'h2'} attached="top">
            {title}
            <div
              style={STYLES.QUESTION_ICON}
            >
              <Popup
                trigger={<Icon name="question" size="small" />}
                content={MESSAGES.SHOW_RECENT_ACTIVITIES}
                position="bottom right"
              />
            </div>
          </Header>
          <Segment
            attached
            loading={isFetching}
            style={{
              height: isMobile ? CHART_HEIGHT_MOBILE : CHART_HEIGHT,
            }}
          >
            {
              hasRecentActivities ? (
                <ResponsiveBar
                  theme={getNivoTheme(isMobile)}
                  data={data.map(({ date, count }) => ({
                    date: formatDatetime(date),
                    文章數: count.post,
                    評論數: count.comment,
                  }))}
                  keys={['文章數', '評論數']}
                  indexBy="date"
                  margin={{ top: 20, right: isMobile ? 20 : 130, bottom: 80, left: 50 }}
                  padding={0.3}
                  valueScale={{ type: 'symlog' }}
                  indexScale={{ type: 'band', round: true }}
                  colors={['#61cdbb', '#f47560']}
                  borderColor={{
                    from: 'color',
                    modifiers: [['darker', 1.6]],
                  }}
                  axisTop={null}
                  axisRight={null}
                  axisBottom={{
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: isMobile ? -80 : -45,
                    legendPosition: 'middle',
                    legendOffset: 32,
                  }}
                  axisLeft={{
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: 0,
                    legendPosition: 'middle',
                    legendOffset: -40,
                  }}
                  labelSkipWidth={12}
                  labelSkipHeight={12}
                  labelTextColor={{
                    from: 'color',
                    modifiers: [['darker', 1.6]],
                  }}
                  legends={isMobile ? [] : [
                    {
                      dataFrom: 'keys',
                      anchor: 'bottom-right',
                      direction: 'column',
                      justify: false,
                      translateX: 120,
                      translateY: 0,
                      itemsSpacing: 2,
                      itemWidth: 100,
                      itemHeight: 20,
                      itemDirection: 'left-to-right',
                      itemOpacity: 0.85,
                      symbolSize: 20,
                      effects: [
                        {
                          on: 'hover',
                          style: {
                            itemOpacity: 1,
                          },
                        },
                      ],
                    },
                  ]}
                  animate
                  motionStiffness={90}
                  motionDamping={15}
                />
              ) : (
                <p>似乎潛水一陣子了呢...</p>
              )
            }
          </Segment>
        </CustomContainer>
      </div>
    );
  }
}
